module.exports = __webpack_public_path__ + "img/cyberpunk-min.f88cb536.png";